// src/com/dc_info/DcInfo.js
import React, { useEffect, useRef, useState } from 'react';
//import { styled } from '@mui/material/styles';
import { CircularProgress, IconButton } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached'; // refresh
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite'; // 사용
import StopCircleIcon from '@mui/icons-material/StopCircle'; // 사용중지.
import PageviewIcon from '@mui/icons-material/Pageview';
import { useLazyQuery, useMutation, useReactiveVar } from '@apollo/client';
import { useSnackbar } from 'notistack';
import SearchBox from '../../common/SearchBox';
import {ContentConainer, ContentHeader, ControlBox, ToolBox} from '../../common/TopViewControl';
import { useConfirmDialog } from '../../common/AppConfirmDialog';
import FlexyTable from '../../common/flexytable/FlexyTable';
import { AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { authTableTreeRepo, dcInfoListRepo } from '../../value/AppModel';
import {
    LIST_DC_INFO, GET_DC_INFO,
    ADD_DC_INFO, EDIT_DC_INFO, SET_USAGE_DC_INFO
} from './DcInfoGql';
import { DcInfoDictionary } from './DcInfoDict';
import { useAlertSetter, useAuthorizationCheck } from '../../api/app-hook';
import DcInfoView from './DcInfoView';
import DcInfoInput from './DcInfoInput';

/**
 * (DC_INFO) 정보 View Controller
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-08-26 18:04:50 using DbdbTap
 */
export default function DcInfo({
    viewServiceTags,
    show = true,
}) {
    const [viewerState, setViewerState] = useState(AppObject.EmptyViewerState);
    const [editorState, setEditorState] = useState(AppObject.EmptyViewerState);
    const dcInfoListData = useReactiveVar(dcInfoListRepo);
    const [searchText, setSearchText] = useState('');
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();
    const openConfirmDialog = useConfirmDialog();
    const addAlert = useAlertSetter();
    const { enqueueSnackbar } = useSnackbar();
    const lastReloadRef = useRef(0);
    const isEditingRef = useRef(false); // 플래그 생성

    // ##### Call GraphQL to get List #####
    const [getDcInfoList, responseList] = useLazyQuery(LIST_DC_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => addAlert({title: DcInfoDictionary.errorTitle.Get, message: [error.message]})
    });
    const [getDcInfoItem, responseItemToEdit] = useLazyQuery(GET_DC_INFO, {
		...AppObject.NoCachedFetch,
		onCompleted: (data, option) => {onCompleteGetItem(data, option)},
		onError: (error) => addAlert({title: DcInfoDictionary.errorTitle.Get, message: [error.message]})
	});
    
    // ##### GraphQL Mutation. 'onError' for prevent from printing error at console (Uncaught exception) ###
    const [addDcInfo, responseAdd] = useMutation( ADD_DC_INFO, {
		onCompleted: (data, option) => onCompleteAdd(data, option), 
		onError: (error) => addAlert({title: DcInfoDictionary.errorTitle.Add, message: [error.message]})
	} );
    const [editDcInfo, responseEdit] = useMutation( EDIT_DC_INFO, {
		onCompleted: (data, option) => onCompleteEdit(data, option),
		onError: (error) => addAlert({title: DcInfoDictionary.errorTitle.Edit, message: [error.message]})
	} );
    /* const [removeDcInfo, responseRemove] = useMutation( REMOVE_DC_INFO, {
		onCompleted: (data, option) => onCompleteRemove(data, option),
		onError: (error) => addAlert({title: DcInfoDictionary.errorTitle.Remove, message: [error.message]})
	}); */
    const [setUsageDcInfo, responseSetUsage] = useMutation( SET_USAGE_DC_INFO, {
        onCompleted: (data, option) => onComplateSetUsage(data, option),
        onError: (error) => addAlert({title: DcInfoDictionary.errorTitle.SetUsage, message: [error.message]})
    });

    const getDcInfoListNow = () => {
        getDcInfoList();
        lastReloadRef.current = new Date().getTime()/1000;
    };

    useEffect(() => {
        const diff = new Date().getTime()/1000 - dcInfoListData.when;
        if(diff > 300)
            getDcInfoListNow();
    }, []);


    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.dcInfoList) {
            dcInfoListRepo({when:new Date().getTime()/1000, records:data.dcInfoList});
        }
    };

    const onCompleteGetItem = (data, option) => {
        if(data.dcInfoItem) {
            if(isEditingRef.current) setEditorState({open:true, item:data.dcInfoItem});
            else setViewerState({open:true, item:data.dcInfoItem});
        }
        else addAlert({title:DcInfoDictionary.errorTitle.Get, message:['출발지 정보를 찾을 수 없습니다.']});
    };

    const onCompleteAdd = (data, clientOption) => {
        if(data.dcInfoAdd.ok) {
            setEditorState(AppObject.EmptyViewerState);
            // getDcInfoListNow();
            dcInfoListRepo({when:new Date().getTime()/1000, records:data.dcInfoAdd.list});
        }
        else addAlert({title:DcInfoDictionary.errorTitle.Add, message:[data.dcInfoAdd.message]});
    };

    const onCompleteEdit = (data, clientOption) => {
        if(data.dcInfoEdit.ok) {
            setEditorState(AppObject.EmptyViewerState);
            getDcInfoListNow();
            dcInfoListRepo({when:new Date().getTime()/1000, records:data.dcInfoEdit.list});
        }
        else addAlert({title:DcInfoDictionary.errorTitle.Edit, message:[data.dcInfoEdit.message]});
    };

    /* const onCompleteRemove = (data, clientOption) => {
        if(data.dcInfoRemove.ok) {
            // getDcInfoListNow();
            dcInfoListRepo({when:new Date().getTime()/1000, records:data.dcInfoRemove.list});
        }
        else addAlert({title:DcInfoDictionary.errorTitle.Remove, message:[data.dcInfoRemove.message]});
    }; */

    const onComplateSetUsage = (data, clientOption) => {
        if(data.dcInfoSetUsage.ok) {
            dcInfoListRepo({when:new Date().getTime()/1000, records:data.dcInfoSetUsage.list});
        }
        else addAlert({title:DcInfoDictionary.errorTitle.SetUsage, message:[data.dcInfoSetUsage.message]});
    }

    // >>>>>>>>> Event Handler <<<<<<<<<<<<<

    const onClickReload = () => {
        const diff = new Date().getTime()/1000 - lastReloadRef.current;
        if(diff < 3) {
            enqueueSnackbar(AppWord.ReloadNotIn3Sec, {variant:'info', autoHideDuration:2000});
        }
        else getDcInfoListNow();
    };

    const onRequestSave = (item, isEdit) => {
        const mutateParam = {variables:{dcInfo:item}};
        if(isEdit) editDcInfo(mutateParam);
        else addDcInfo(mutateParam);
    };

    const onClickAdd = () => {
        setEditorState({open:true, item:null});
    };

    const onRequestEdit = (item) => {
        isEditingRef.current = true;
        getDcInfoItem({variables:{dcCd:item.dcCd}});
    };

    /* const confirmRemove = async (item) => {
        const confirm = await openConfirmDialog({
            title: "출발지 정보 삭제",
            content: [
                `출발지(${item.dcName}) 정보를 삭제하시겠습니까?`,
                '출발지 정보는 다양한 데이터와 업무에 사용됩니다.',
                '삭제 후 복구할 수 없습니다. 계속하시겠습니까?'
            ]
        });

        if(confirm)
            removeDcInfo({variables:{dcInfo:{dcCd:item.dcCd}}});
    }; */

    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    const onDoubleClickRow = (record) => {
        isEditingRef.current = false;
        getDcInfoItem({variables:{dcCd:record.dcCd}});
    };

    const onCloseView = () => {
        setViewerState(AppObject.EmptyViewerState);
    };

    const onRequestEditFromViewer = (item) => {
        setViewerState(AppObject.EmptyViewerState);
        setEditorState({open: true, item: item});
    };

    const alertNoRemove = (item) => {
        addAlert({
            title: '출발지 삭제 제한',
            message: [
                `출발지(${item.dcName}) 정보는 삭제할 수 없습니다.`,
                '출발지 정보는 다양한 데이터와 업무에 사용됩니다.',
                '시스템 관리자에게 문의하세요.'
            ]
        })
    };

    const confirmStopUsing = async (item) => {
        const confirm = await openConfirmDialog({
            title: "출발지 사용중지",
            content: [
                `${item.dcName} 출발지를 사용중지하시겠습니까?`,
            ]
        });

        if(confirm)
            setUsageDcInfo({variables:{dcInfo:{dcCd:item.dcCd, useYn:'N'}}});
    };

    const confirmReusing = async (item) => {
        const confirm = await openConfirmDialog({
            title: "출발지 사용 복귀",
            content: [
                `${item.dcName} 출발지를 사용으로 변경하시겠습니까?`,
            ]
        });

        if(confirm)
            setUsageDcInfo({variables:{dcInfo:{dcCd:item.dcCd, useYn:'Y'}}});
    };

    const onClickToolOnRow = (toolId, row) => {
        switch(toolId) {
            case AppObject.command.DELETE: alertNoRemove(row); break;
            case AppObject.command.EDIT: onRequestEdit(row); break;
            case AppObject.command.STOP_USING: confirmStopUsing(row); break;
            case AppObject.command.REUSE: confirmReusing(row); break;
            case AppObject.command.VIEW: onDoubleClickRow(row); break;
            default: return;
        }
    };

    const canAdd = checkAuth(authTableTree.tree.pr_dc_info_add);
    const canEdit = checkAuth(authTableTree.tree.pr_dc_info_edit);
    const canRemove = checkAuth(authTableTree.tree.pr_dc_info_remove);
    const canSetUsage = checkAuth(authTableTree.tree.pr_dc_info_set_usage);
    //const canSetZone = checkAuth(authTableTree.tree.pr_dc_info_set_zone);

    const tools = [
        {id:AppObject.command.VIEW, icon:<PageviewIcon/> }
    ];
    
    if(canEdit) tools.push({id:AppObject.command.EDIT, icon:<EditIcon/>});
    if(canSetUsage) {
        tools.push({id:AppObject.command.STOP_USING, icon:<StopCircleIcon/>, color: AppStyle.mui.error, where:(row)=>row.useYn === "Y"});
        tools.push({id:AppObject.command.REUSE, icon:<PlayCircleFilledWhiteIcon/>, color: AppStyle.mui.success, where:(row)=>row.useYn !== "Y"});
    }
    if(canRemove) tools.push({id:AppObject.command.DELETE, icon:<DeleteForeverIcon/>, color: AppStyle.mui.disabled});

    const loadingAny
    = responseList.loading
    || responseItemToEdit.loading
    || responseAdd.loading
    || responseEdit.loading
    || responseSetUsage.loading;

    const rootStyle = show ? undefined : {display:'none', visibility:'hidden', pointerEvents:'none'};

    return(
        <ContentConainer style={rootStyle}>
            {viewServiceTags}
            <ContentHeader>
                <ControlBox>
                    <SearchBox
                        value={searchText}
                        onChangeText={onChangeSearchText}
                    />
                </ControlBox>
                <ToolBox>
                    {
                        loadingAny ?
                        <CircularProgress size={20} />
                        :
                        <IconButton
                            color={AppStyle.mui.inherit}
                            onClick={onClickReload}
                        >
                            <CachedIcon />
                        </IconButton>
                    }
                    {
                        canAdd &&
                        <IconButton
                            color={AppStyle.mui.primary}
                            style={{marginLeft:10}}
                            onClick={onClickAdd}
                        >
                            <NoteAddIcon />
                        </IconButton>
                    }
                </ToolBox>
            </ContentHeader>
            <FlexyTable
                name={DcInfoDictionary.tableProps.tableId}
                tableProps={DcInfoDictionary.tableProps}
                records={dcInfoListData.records}
                search={searchText}
                tools={tools}
                onClickTool={onClickToolOnRow}
                onRowDoubleClicked={onDoubleClickRow}
            />
            <DcInfoView
                open={viewerState.open}
                item={viewerState.item}
                onRequestEdit={onRequestEditFromViewer}
                onClose={onCloseView}
            />
            <DcInfoInput
                open={editorState.open}
                item={editorState.item}
                onClose={()=>setEditorState(AppObject.EmptyViewerState)}
                responseSaving={editorState.item ? responseEdit : responseAdd}
                onRequestSave={onRequestSave}
            />
        </ContentConainer>
    );
}
